import { ListOwnQuotesReq } from '#/unified-rfqs/repositories/grfq-types';
import OrdersStore from '#/unified-rfqs/store/orders';
import { isOpenOrder, Order } from '#/unified-rfqs/entities/shared';
import { GrfqService } from '#/unified-rfqs/services/grfq';
import { MergedSourcesFetcher } from '#/unified-rfqs/services/merged-sources-fetcher';
import { DrfqService } from '#/unified-rfqs/services/drfq';
import PublicStore from '#/unified-rfqs/store/public-store';

interface OrdersServiceDeps {
  ordersStore: OrdersStore;
  grfqService: GrfqService;
  drfqService: DrfqService;
}

const PAGE_SIZE = 50;

export default class OpenOrdersService extends PublicStore<Order> {
  readonly fetcher: MergedSourcesFetcher<ListOwnQuotesReq, Order>;

  constructor(deps: OrdersServiceDeps) {
    const { grfqService, drfqService, ordersStore } = deps;
    super(ordersStore);
    this.fetcher = new MergedSourcesFetcher<ListOwnQuotesReq, Order>({
      pageSize: PAGE_SIZE,
      fetchers: [
        async ({ pageSize, cursor }) =>
          grfqService.listOwnQuotes({ pageSize, cursor, status: 'OPEN' }),
        async ({ pageSize, cursor }) =>
          drfqService.listOrders({ pageSize, cursor, state: 'OPEN' }),
      ],
      store: ordersStore,
      filterFn: isOpenOrder,
    });
  }
}
